import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';

import "assets/css/material-dashboard-react.css?v=1.5.0";

import indexRoutes from "routes/index.jsx";
import Login from "views/Login/Login";

import { isAuthenticated } from "baseparking-api/Auth.js";
import { connect } from "react-redux";
import { refreshUser } from "./actions/AuthActions";
const hist = createBrowserHistory();
class Application extends Component {
  constructor() {
    super();
  }

  componentWillMount() {
    if (this.props.user.username === "") {
      this.props.refreshUser();
    }
  }

  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} >
        <Router history={hist}>
          <Switch>
            <Route path="/login" component={Login} />
            {(isAuthenticated() &&
              indexRoutes.map((prop, key) => {
                return (
                  <Route path={prop.path} component={prop.component} key={key} />
                );
              })) || <Redirect to="/login" />}
          </Switch>
        </Router>
      </MuiPickersUtilsProvider>
    );
  }
}
function mapStateToProps(state) {
  return {
    user: state.auth
  };
}
function mapDispatchToProps(dispatch) {
  return {
    refreshUser: () => dispatch(refreshUser())
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/App.js